// @ts-nocheck
import React, { useState } from 'react';

interface CreateCollectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (data: { name: string; description: string; color: string }) => Promise<any>;
  onSuccess?: (collection: any) => void;
}

const PRESET_COLORS = ['#2563eb', '#10b981', '#f59e0b', '#ec4899', '#8b5cf6', '#64748b'];

export default function CreateCollectionModal({
  isOpen,
  onClose,
  onCreate,
  onSuccess,
}: CreateCollectionModalProps) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [color, setColor] = useState('#2563eb');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;

    setIsSubmitting(true);
    setError('');
    try {
      const result = await onCreate({
        name: name.trim(),
        description: description.trim(),
        color,
      });
      setName('');
      setDescription('');
      if (onSuccess) {
        onSuccess(result);
      }
      onClose();
    } catch (err: any) {
      setError(err.message || 'Failed to create collection.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="reader-modal-overlay"
      style={{ zIndex: 10005 }}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div className="reader-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="reader-modal-header">
          <h3 className="reader-modal-title">New Collection</h3>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: '1.2rem', cursor: 'pointer', color: 'var(--reader-text-muted)' }}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="reader-modal-body">
            {error && (
              <div
                style={{
                  padding: '8px 12px',
                  background: 'rgba(239, 68, 68, 0.1)',
                  border: '1px solid #ef4444',
                  borderRadius: '4px',
                  color: '#ef4444',
                  fontSize: '0.85rem',
                }}
              >
                {error}
              </div>
            )}

            <div className="reader-form-group">
              <label className="reader-form-label">Collection Name *</label>
              <input
                type="text"
                className="reader-input"
                placeholder="e.g. Distributed Systems, Product Design, Long Reads"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
                required
              />
            </div>

            <div className="reader-form-group">
              <label className="reader-form-label">Description (optional)</label>
              <input
                type="text"
                className="reader-input"
                placeholder="Brief purpose of this collection..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <div className="reader-form-group">
              <label className="reader-form-label">Color Label</label>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                {PRESET_COLORS.map((c) => (
                  <button
                    key={c}
                    type="button"
                    onClick={() => setColor(c)}
                    style={{
                      width: '26px',
                      height: '26px',
                      borderRadius: '50%',
                      backgroundColor: c,
                      border: color === c ? '2px solid var(--reader-text)' : '2px solid transparent',
                      cursor: 'pointer',
                      padding: 0,
                    }}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="reader-modal-footer">
            <button type="button" className="reader-btn" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </button>
            <button
              type="submit"
              className="reader-btn reader-btn-primary"
              disabled={isSubmitting || !name.trim()}
            >
              {isSubmitting ? 'Creating…' : 'Create Collection'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
